import React from "react";
import { Edit, Settings, Upload, Wrench, User, Info } from "lucide-react";
// shadcn/ui components
import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";
import { Button } from "@shared/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@shared/ui/tooltip";
const QuickActions = ({
  meter,
  onEditMeter,
  onUpdatePremise,
  onUploadReading,
  onGenerateServiceOrder,
  onUpdateConsumer,
}) => {
  const actions = [
    {
      id: "edit-meter",
      label: "Edit Meter",
      icon: Edit,
      onClick: onEditMeter,
      description: "Modify meter details and configuration",
    },
    {
      id: "update-premise",
      label: "Update Premise",
      icon: Settings,
      onClick: onUpdatePremise,
      description: "Update premise information",
    },
    {
      id: "upload-reading",
      label: "Upload Reading",
      icon: Upload,
      onClick: onUploadReading,
      description: "Upload a new meter reading",
    },
    {
      id: "generate-service-order",
      label: "Create Service Order",
      icon: Wrench,
      onClick: onGenerateServiceOrder,
      description: "Create a new service order for this meter",
    },
    {
      id: "update-consumer",
      label: "Update Consumer",
      icon: Settings,
      onClick: onUpdateConsumer,
      description: "Update consumer information",
      disabled: meter?.status === "Assigned",
    },
  ];
  return (
    <Card className="w-full">
      <CardHeader>
        <div className="flex items-center gap-2">
          <CardTitle className="text-lg font-semibold">Quick Actions</CardTitle>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger>
                <Info className="h-4 w-4 text-muted-foreground" />
              </TooltipTrigger>
              <TooltipContent>
                <p>Common actions for this meter</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
      </CardHeader>
      <CardContent className="space-y-2">
        {actions.map((action) => {
          const Icon = action.icon;
          return (
            <Button
              key={action.id}
              variant="outline"
              className="w-full justify-start gap-3 h-auto py-3 px-4 hover:bg-accent"
              onClick={action.onClick}
              disabled={action.disabled}
            >
              <Icon className="h-4 w-4 flex-shrink-0" />
              <span className="font-medium">{action.label}</span>
            </Button>
          );
        })}
      </CardContent>
    </Card>
  );
};
export default QuickActions;
